import LinearProgress from './LinearProgress'

export default LinearProgress
